import React from "react"
import { Link } from "gatsby"
import TextTruncate from "react-text-truncate"
import Card from "react-bootstrap/Card"
import _ from "lodash"
import PdfIcon from "./pdf-icon"

const MediaItemTemplate = ({ item }) => {
  // @TODO: need to remove escape characters from MD.
  const title = item.frontmatter.title
  const alt = _.truncate(item.frontmatter.title, {
    length: 75,
    omission: "..."
  })
  const name = item.frontmatter.name
  const mid = item.frontmatter.mid
  const path = item.frontmatter.path
  const ext = item.frontmatter.ext
  const type = item.frontmatter.type
  let assetSrc
  let thumbnail
  // Get the correct asset for the type of media.
  switch (type) {
    case "document":
      thumbnail = <PdfIcon />
      break
    case "image":
      assetSrc = `${path}/${name}-relatedinfo.${ext}`
      thumbnail = <Card.Img variant="top" src={assetSrc} alt={alt} />
      break
    case "video":
      assetSrc = `${path}/${name}.${ext}`
      thumbnail = (
        <div>
          {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
          <video controls poster={`${path}/${name}.jpg`}>
            <source src={assetSrc} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      )
      break
    default:
      assetSrc = `${path}/${name}-relatedinfo.${ext}`
      thumbnail = <img src={assetSrc} alt={alt} />
      break
  }

  return (
    <Card className="media-result">
      <Card.Body>
        {thumbnail}
        <Card.Text as="div">
          <h5>
            <Link to={`/media/${mid}`}>
              <TextTruncate line={4} truncateText="..." text={title} />
            </Link>
          </h5>
        </Card.Text>
      </Card.Body>
    </Card>
  )
}

export default MediaItemTemplate
